<template>
  <BaseLayout>
    <TimelineLoading :loading="isLoading" step="DADOS_PESSOAIS">
      <div class="flex w-full sm:w-1/2 xl:w-1/3 items-center justify-center">
        <OfferDetailContext step="SMS" :offer="offer" :isAccordionOpen="false" :keepAccordionOpen="false" :colorSolid="false" :mobileOnly="true">
          <div class="flex flex-col py-10 items-center w-full gap-5">
              <div>
                <mdn-heading :level="2" size="md">
                  Código de verificação
                </mdn-heading>
                <mdn-text>
                  Por favor, digite o código enviado por SMS para o seu número de celular
                </mdn-text>
              </div>
              <OfferSwitchModal ref="offerSwitchModal"/>
              <TokenForm :error="error" :msisdn="msisdn" @submit="onSubmitOtp" />
          </div>
        </OfferDetailContext>
      </div>
    </TimelineLoading>
  </BaseLayout>
</template>

<script>
import { singleOfferMixin } from 'business/offers/mixins'
import { loadUserDataMixin } from 'business/user/mixins'
import { serviceBuilder as userService } from '@/business/user/service'
import { useHttpServiceMixin } from '@/common/use-http'
import { formatMsisdn } from '@/common/format'
import TokenForm from './TokenForm'
import { AcaoPermitidaParaPlanoEscolhidoEnum } from 'business/http/dto/ConfirmOTPResponse'
import { MdnHeading, MdnText } from 'mondrian-vue'
import TimelineLoading from '../../components/TimelineLoading.vue'
import OfferSwitchModal from '../../components/OfferSwitchModal.vue'
import OfferDetailContext from '../../components/OfferDetailContext.vue'

const CONFIRM_OTP_ERROR_MESSAGE = 'Falha na validação do token'

export default {
  name: 'page-sms-token',
  title: 'Token de acesso',
  components: { TimelineLoading, TokenForm, MdnHeading, MdnText, OfferSwitchModal, OfferDetailContext },
  mixins: [
    singleOfferMixin,
    loadUserDataMixin,
    useHttpServiceMixin({ userService })
  ],
  data () {
    return {
      isProcessing: false,
      error: false,
      isModalOpen: false
    }
  },
  computed: {
    isLoading () {
      return this.isOfferLoading || this.isProcessing
    },
    msisdn () {
      return formatMsisdn(this.userData.msisdn)
    }
  },
  onOfferError: {
    name: 'page-1-step'
  },
  onUserDataError: {
    name: 'page-2-step'
  },
  methods: {
    async onSubmitOtp (otp) {
      this.isProcessing = true
      this.error = false
      await this.loadUserAndPlanSituation()
      const { userData, offerId, userOfferSituation } = this
      try {
        const isActionOfferSwitch = userOfferSituation === AcaoPermitidaParaPlanoEscolhidoEnum.TROCA
        await this.$userService.validateUserAndSelectPlan(userData.cpf, userData.msisdn, offerId, isActionOfferSwitch, otp)

        this.$tracker.log('clique:codigo-confirmacao', 'tentativa:sucesso')
        this.isProcessing = false

        this.$refs.offerSwitchModal.goToSwitchOrAdquirePage(userOfferSituation, userData.msisdn)
      } catch (err) {
        this.$tracker.error(err)
        this.$tracker.log('clique:codigo-confirmacao', 'tentativa:erro')
        this.isProcessing = false
        this.error = CONFIRM_OTP_ERROR_MESSAGE

        setTimeout(() => {
          this.error = false
        }, 3000)
      }
    }
  }
}
</script>
